import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login/Login";
import Formulario from "./pages//Formulario/Formulario";
import FormularioRevision from "./pages/FormularioRevision/FormularioRevision";
import FeedPostulante from "./pages/FeedPostulante/FeedPostulante";
import FeedEvaluador from "./pages/FeedEvaluador/FeedEvaluador";
import FeedAdmin from "./pages/FeedAdmin/FeedAdmin";
import MiPerfil from "./pages/MiPerfil/MiPerfil";
import MiPDF from "./pages/Bases/Bases";

function App() {
  return (
    <Router>
      {" "}
      {/* Ensure only one Router is used at the top level */}
      <div>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/Formulario" element={<Formulario />} />
          <Route path="/FeedPostulante" element={<FeedPostulante />} />
          <Route path="/FormularioRevision" element={<FormularioRevision />} />
          <Route path="/FeedEvaluador" element={<FeedEvaluador />} />
          <Route path="/FeedAdmin" element={<FeedAdmin />} />
          <Route path="/MiPerfil" element={<MiPerfil />} />
          <Route path="/Bases" element={<MiPDF />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
